// https://gist.github.com/wmhilton/7256c66c4e28f02c018e
// Vanilla Cookies - a dead simple yet full-featured JavaScript cookie library
// derived from http://stackoverflow.com/a/19189846

export const SESSION_NAME = 'STD_LOGIN_SESSION';

export function setCookie(sessionInformation:any, sessionName: string = SESSION_NAME,expirationMonth: number = 2){
    // Set a cookie
    const expiration = new Date();
    expiration.setMonth(expiration.getMonth() + expirationMonth);
    const sCookie = encodeURIComponent(sessionName) + '=' + JSON.stringify({...sessionInformation})+ '; expires='+expiration;
    document.cookie = sCookie;
}

export function getCookie(sessionName: string = SESSION_NAME){
    // Set a cookie
    let session = '{}';
    const match = document.cookie.match(new RegExp('(^| )' + sessionName + '=([^;]+)'));
    if (match) {
        session = match[2]
    }
    return session.includes('{') ? JSON.parse(session) : session;
}


export function deleteCookie(sessionName: string = SESSION_NAME)
{
    const sCookie = encodeURIComponent(sessionName) + '=' + JSON.stringify({})+ ';expires='+new Date();
    document.cookie = sCookie;
};